module.exports = __webpack_public_path__ + "static/hotels-lodging-1.f0fdbe17.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/hotels-lodging-1.jpg
// module id = 512
// module chunks = 157614979532788